/**
 * <fiep-counter target="120" duration="1800">
 *   <span data-fiep-counter-value>0</span>
 * </fiep-counter>
 *
 * Animates the inner value from 0 → target the first time the element scrolls into view.
 * Respects prefers-reduced-motion (jumps directly to target).
 */
class FiepCounter extends HTMLElement {
  constructor() {
    super();
    this.played = false;
  }

  connectedCallback() {
    const target = this.parseTarget();
    if (target == null) return;
    const valueEl = this.querySelector('[data-fiep-counter-value]');
    if (!valueEl) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      valueEl.textContent = this.formatValue(target);
      this.played = true;
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this.played) {
            this.played = true;
            this.animate(valueEl, target);
            observer.disconnect();
            break;
          }
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(this);
  }

  parseTarget() {
    const raw = this.getAttribute('target');
    if (raw == null) return null;
    const n = parseFloat(raw.replace(/[^0-9.+-]/g, ''));
    return Number.isFinite(n) ? n : null;
  }

  formatValue(n) {
    // Preserve integer formatting; default to no decimals.
    return Math.round(n).toString();
  }

  animate(el, target) {
    const duration = parseInt(this.getAttribute('duration') || '1600', 10);
    const start = performance.now();
    const from = 0;
    const ease = (t) => 1 - Math.pow(1 - t, 3); // ease-out cubic

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const value = from + (target - from) * ease(t);
      el.textContent = this.formatValue(value);
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
}

if (!customElements.get('fiep-counter')) {
  customElements.define('fiep-counter', FiepCounter);
}
